import { render, staticRenderFns } from "./passcard.vue?vue&type=template&id=fed5c9d0&scoped=true&"
import script from "./passcard.vue?vue&type=script&lang=js&"
export * from "./passcard.vue?vue&type=script&lang=js&"
import style0 from "./passcard.vue?vue&type=style&index=0&id=fed5c9d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed5c9d0",
  null
  
)

export default component.exports